var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgWater = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 30,
    viewBox: "0 0 23 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3422_610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4997 23.9062C10.8317 23.9062 10.1824 23.6906 9.65236 23.2928C9.12235 22.8949 8.74134 22.3371 8.56836 21.7058",
    stroke: "#1C5F75",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.10941 4.13227C10.0669 2.5401 10.5454 1.74401 11.2307 1.62299C11.409 1.59149 11.5917 1.59149 11.77 1.62299C12.4552 1.74401 12.9338 2.5401 13.8912 4.13227L16.4226 8.34216C18.1919 11.2844 19.5722 14.4343 20.5309 17.7164C22.0886 23.0499 17.9948 28.3592 12.3245 28.3592H10.6761C5.00585 28.3592 0.912065 23.0499 2.4698 17.7164C3.42841 14.4343 4.80882 11.2844 6.57798 8.34216L9.10941 4.13227Z",
    stroke: "#1C5F75",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3422_610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 30,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWater, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/water.45257aad.svg";
export { ForwardRef as ReactComponent };